import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map, delay } from 'rxjs/operators';

import {  FamilyEvents, EventAlbum } from '../Models/common.model';

@Injectable({
    providedIn: 'root'
})
export class FamilyeventGallaryService {
    private apiURL = window.location.href;// window.location.href;

    constructor(private http: HttpClient) {

    }
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }
   
    loadPostScrollImages(pageNumber: number): Observable<EventAlbum[]> {
        return this.http.get<EventAlbum[]>(this.apiURL + '&pagesize=12&pagenumber=' + pageNumber)
            .pipe(
                (delay(0)),///delay of number of seconds to load the next set of images on scroll. 
                retry(1),
                catchError(this.handleError)
            )
    }

    getFamilyEventsbyYear(): Observable<any> {
        return this.http.get<any>(`${this.apiURL}/GetEvents`)
            .pipe(
                (delay(0)),
                retry(1),
                catchError(this.handleError)
            )
    }

    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }
}
